/* TrendHome Reviews — Étoiles dans les cartes produit */
(() => {
  const API = "https://trendhome-reviews.netlify.app/.netlify/functions";

  const starSVG = (fill) =>
    `<svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true" style="display:block"><path fill="${fill}" d="M12 2.6l2.9 5.9 6.5.9-4.7 4.6 1.1 6.5L12 17.4l-5.8 3.1 1.1-6.5L2.6 9.4l6.5-.9L12 2.6z"/></svg>`;

  const starsHTML = (avg) => {
    const full = Math.round(avg);
    let out = "";
    for (let i = 1; i <= 5; i++) out += starSVG(i <= full ? "#e8a33d" : "#e5e2dc");
    return out;
  };

  function handleFromHref(href) {
    const m = href && href.match(/\/products\/([a-z0-9\-_%]+)/i);
    return m ? decodeURIComponent(m[1]).toLowerCase() : null;
  }

  function findCards() {
    const map = new Map();
    document.querySelectorAll('a[href*="/products/"]').forEach((a) => {
      const handle = handleFromHref(a.getAttribute("href"));
      if (!handle) return;
      const card = a.closest(
        "product-card, .product-card, [data-product-card], .card, li, article, .product-grid__item"
      );
      if (!card) return;
      if (card.closest("#trh-reviews")) return;
      if (!map.has(handle)) map.set(handle, new Set());
      map.get(handle).add(card);
    });
    return map;
  }

  function insertBadge(card, data) {
    if (card.querySelector(".trh-card-rating")) return;
    const price = card.querySelector('[class*="price"], product-price, .price');
    const badge = document.createElement("div");
    badge.className = "trh-card-rating";
    badge.setAttribute("aria-label", `${data.average} sur 5 (${data.total} avis)`);
    badge.style.cssText =
      "display:flex;align-items:center;gap:5px;margin-top:4px;font-size:12.5px;color:#6b6862;line-height:1";
    badge.innerHTML =
      `<span style="display:inline-flex;gap:1px">${starsHTML(data.average)}</span>` +
      `<span>${String(data.average).replace(".", ",")} (${data.total})</span>`;
    if (price && price.parentNode) price.parentNode.insertBefore(badge, price.nextSibling);
    else card.appendChild(badge);
  }

  async function run() {
    const map = findCards();
    if (!map.size) return;
    const handles = [...map.keys()];
    for (let i = 0; i < handles.length; i += 40) {
      const batch = handles.slice(i, i + 40);
      try {
        const res = await fetch(`${API}/ratings?handles=${encodeURIComponent(batch.join(","))}`);
        if (!res.ok) return;
        const data = await res.json();
        for (const [handle, agg] of Object.entries(data.ratings || {})) {
          if (!agg || !agg.total) continue;
          (map.get(handle) || []).forEach((card) => insertBadge(card, agg));
        }
      } catch { /* API indisponible : silence */ }
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run);
  else run();

  setTimeout(run, 1500);
})();
